import { CircleSkeleton, Skeleton } from '@/_components';

export function SingleLoader() {
  return (
    <div className="flex w-full justify-end gap-1">
      <div className="h-11 pt-4">
        <CircleSkeleton className="size-7 shrink-0 grow-0" />
      </div>
      <div className="h-11 pt-4">
        <CircleSkeleton className="size-7 shrink-0 grow-0" />
      </div>
      <div className="h-11 flex-1 pt-4">
        <Skeleton className="h-7 w-full" />
      </div>
    </div>
  );
}
